module.exports = __webpack_public_path__ + "img/01-T.837abf61.png";